export default class CreateKpiTargetRequest {
    branchId: string | null = null;
    deskId: string | null = null;
    agencyUserId: string | null = null;
    kpiCode = '';
    periodType = 0;
    effectiveFrom = '';
    effectiveTo: string | null = null;
    targetValue = 0;
    reportingPeriodId: string | null = null;

    // Dimension filter IDs
    activityCategoryIds: string[] = [];
    positionIds: string[] = [];
    locationTypeIds: string[] = [];
    skillIds: string[] = [];
    qualificationIds: string[] = [];

    // Visibility
    visibilityType = 1;
    visibilityGroupId: string | null = null;
}
